import React from "react";
import { Link } from "react-router-dom";

const GlobalCapabilityCentersLayout = () => {
    return (
        <div className="bg-white text-gray-900">

            {/* ================= HERO ================= */}
            <section
                className="relative min-h-[85vh] flex items-center"
                style={{
                    backgroundImage:
                        "url(/images/global/hero.png)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="absolute inset-0 bg-indigo-900/70" />
                <div className="relative w-full px-6 md:px-16 lg:px-24 py-24 text-white text-left">
                    <span className="text-sm uppercase tracking-wide text-orange-400">
                        Services
                    </span>
                    <h1 className="text-5xl md:text-6xl font-bold mt-3 mb-6">
                        Your GCC. Re-imagined.
                    </h1>
                    <p className="text-xl max-w-3xl text-indigo-100 mb-8">
                        Build AI-enabled Global Capability Centers designed for speed,
                        scale, innovation, and long-term value creation.
                    </p>
                    <Link
                        to="/contact"
                        className="inline-block bg-orange-500 hover:bg-orange-600 px-8 py-4 rounded-lg font-semibold"
                    >
                        Let’s Talk
                    </Link>
                </div>
            </section>

            {/* ================= VIDEO INTRO ================= */}
            <section className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
                <div>
                    <h2 className="text-4xl font-bold mb-6">
                        GCCs Powered by AI and Engineering Excellence
                    </h2>
                    <p className="text-gray-600 mb-6">
                        Modern Global Capability Centers are no longer cost centers.
                        They are innovation hubs driving digital transformation,
                        platform engineering, and enterprise modernization.
                    </p>
                    <ul className="space-y-3 text-gray-700">
                        <li>✔ AI-first operating models</li>
                        <li>✔ Cloud-native engineering teams</li>
                        <li>✔ Domain-aligned delivery pods</li>
                        <li>✔ Secure & scalable foundations</li>
                    </ul>
                </div>
                <div className="rounded-xl overflow-hidden shadow-lg">
                    <iframe
                        className="w-full h-64 md:h-80"
                        src="https://www.youtube.com/embed/dQw4w9WgXcQ"
                        title="GCC Video"
                        allowFullScreen
                    />
                </div>
            </section>

            {/* ================= BUSINESS OUTCOMES ================= */}
            <section className="bg-gray-50">
                <div className="max-w-7xl mx-auto px-6 py-20">
                    <h2 className="text-3xl font-bold mb-10 text-center">
                        Delivering Business Outcomes from Day One
                    </h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            "Faster Time-to-Value",
                            "Engineering at Scale",
                            "Enterprise-Grade Governance",
                            "Cloud & Platform Readiness",
                            "AI-Driven Productivity",
                            "Secure Global Operations",
                        ].map((item) => (
                            <div
                                key={item}
                                className="bg-white p-6 rounded-xl shadow"
                            >
                                <h4 className="font-semibold mb-2">{item}</h4>
                                <p className="text-sm text-gray-600">
                                    Designed to accelerate measurable impact across
                                    engineering, operations, and innovation.
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= GCC MODELS ================= */}
            <section className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12">
                <div>
                    <img
                        src="/images/global/gb2.jpg"
                        alt="GCC Team"
                        className="rounded-xl"
                    />
                </div>
                <div>
                    <h2 className="text-4xl font-bold mb-6">
                        GCC Models Built for Speed and Innovation
                    </h2>
                    <p className="text-gray-600 mb-6">
                        Choose from flexible GCC engagement models aligned to your
                        growth, risk, and transformation goals.
                    </p>
                    <ul className="space-y-3 text-gray-700">
                        <li>✔ Build-Operate-Transfer (BOT)</li>
                        <li>✔ Captive GCC setup</li>
                        <li>✔ Co-innovation hubs</li>
                        <li>✔ Outcome-driven delivery centers</li>
                    </ul>
                </div>
            </section>

            {/* ================= CLIENT SUCCESS ================= */}
            <section className="bg-indigo-900 text-white">
                <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-12 items-center">
                    <div>
                        <h2 className="text-3xl font-bold mb-4">
                            Building Engineering Momentum
                        </h2>
                        <p className="text-indigo-200 mb-6">
                            See how enterprises scale engineering excellence and
                            innovation using next-generation GCCs.
                        </p>
                        <Link
                            to="/client-success"
                            className="inline-block bg-orange-500 px-6 py-3 rounded-lg font-semibold"
                        >
                            View Case Study
                        </Link>
                    </div>
                    <img
                        src="/images/global/gb1.png"
                        alt="Client success"
                        className="rounded-xl"
                    />
                </div>
            </section>

            {/* ================= WHY US ================= */}
            <section className="bg-gray-50">
                <div className="max-w-7xl mx-auto px-6 py-20">
                    <h2 className="text-3xl font-bold mb-10 text-center">
                        Why Choose TECHSPR for Your GCC?
                    </h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            "AI-First Engineering DNA",
                            "Deep Domain Expertise",
                            "Proven Global Delivery",
                            "Secure by Design",
                            "Talent Transformation",
                            "Long-Term Partnership Focus",
                        ].map((item) => (
                            <div key={item} className="bg-white p-6 rounded-xl shadow">
                                <p className="font-semibold">{item}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= CTA ================= */}
            <section
                className="relative"
                style={{
                    backgroundImage:
                        "url(/images/global/gb3.jfif)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="absolute inset-0 bg-indigo-900/80" />
                <div className="relative max-w-7xl mx-auto px-6 py-24 text-white text-center">
                    <h2 className="text-4xl font-bold mb-4">
                        Let’s Build Your Next-Gen GCC
                    </h2>
                    <p className="text-indigo-200 mb-8">
                        Partner with TECHSPR to create scalable, intelligent,
                        and future-ready Global Capability Centers.
                    </p>
                    <Link
                        to="/contact"
                        className="inline-block bg-orange-500 px-8 py-4 rounded-lg font-semibold"
                    >
                        Get Started
                    </Link>
                </div>
            </section>

        </div>
    );
};

export default GlobalCapabilityCentersLayout;
